import { IRouteOptions } from "../types/routes";

const isAbsoluteURL = (url: string) => url?.startsWith("http");
const appendMatchAny = (chunks: string[]) => chunks.concat("*");
const prependLocale = (chunks: string[]) => [":locale", ...chunks];

export const buildRouteFromChunks = (
  chunks: string[],
  options: IRouteOptions
) => {
  const isAbsolute = isAbsoluteURL(chunks[0]);
  const { withLocale, matchAny } = options;

  if (isAbsolute) {
    chunks = [chunks[0]];
  }

  if (matchAny) {
    chunks = appendMatchAny(chunks);
  }

  if (withLocale && !isAbsolute) {
    chunks = prependLocale(chunks);
  }

  const path = chunks
    .map((chunk) => (isAbsolute ? chunk : chunk.split("/")))
    .flat()
    .filter((chunk) => chunk?.length > 0)
    .join("/");

  const joinedPath = isAbsolute ? path : "/" + path;

  return joinedPath.replace(/^\/\//g, "/");
};
